import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const skillsService = {
  _url: process.env.REACT_APP_SKILLS_API_URL,

  GetSkillsList(searchQuery, fetch) {
    const [data, setsData] = useState({
      skills: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllSkills(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllSkills(skill_type) {
    const query = skill_type ? `?skill_type=${skill_type}` : '';
    return await Fetch.get(`${this._url}/list${query}`);
  },

  async getSkillDetailByFolder(folder) {
    return await Fetch.get(`${this._url}/detail?folder=${folder}`);
  },
};

export default skillsService;
